<template>
  <div>
    <h4>Client identity adding</h4>

    <form @submit.prevent="addClientIdentity">
      <div class="form-group">
        <label for="type-selector">Type</label>
        <b-form-select
          id="type-selector"
          v-model="type"
          :options="typeOptions"
          autofocus
        />
      </div>

      <div class="form-group">
        <label for="id">Id</label>
        <input v-model="idStr" id="id" class="form-control" required>
      </div>

      <hr>

      <b-button :to="{name: 'player_client_identities'}">Cancel</b-button>
      <b-button type="submit" variant="primary">Add</b-button>
    </form>
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';

import { getClientIdentityTypes      } from '../model/player';
import { getClientIdentityTypeName   } from '../model/player';
import { CLIENT_IDENTITY_TYPE_EXT_ID } from '../model/player';


export default {
  name: 'PlayerClientIdentityAdd',

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      type: CLIENT_IDENTITY_TYPE_EXT_ID,
      typeOptions: getTypeOptions(),

      idStr: '',
    };
  },

  methods: {
    addClientIdentity() {
      notifier.deleteSenderNotifications(this);

      const trimmedIdStr = this.idStr.trim();
      if(trimmedIdStr.length === 0) {
        notifier.showError('Id must be specified.', {sender: this});
        return;
      }

      const formData = new FormData();
      formData.set('type', this.type);
      formData.set('id', trimmedIdStr);

      const url = '/player/' + this.playerId + '/client_identity/add';
      HTTP.post(url, formData)
      .then(() => {
        notifier.showSuccessAfterTransition('Client identity added.');
        this.$router.push({name: 'player_client_identities'});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};

function getTypeOptions() {
  const options = [];

  const values = getClientIdentityTypes();
  for(const value of values) {
    const name = getClientIdentityTypeName(value);
    const option = {
      value: value,
      text: name,
    };
    options.push(option);
  }

  return options;
}
</script>
